(function() {
    let focusTrapHandler = null;
    let previousActiveLevel = null;
    let isKeyboardNavigation = false;

    // Track keyboard vs mouse navigation
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') {
            isKeyboardNavigation = true;
        }
    }, true);

    document.addEventListener('mousedown', function() {
        isKeyboardNavigation = false;
    }, true);

    // Function to set inert state on page content (outside menu)
    function setPageInertState(isInert) {
        const headerEl = document.querySelector('.header-component') || document.querySelector('header');
        const elementsToInert = [];

        const mainEl = document.querySelector('main');
        if (mainEl) elementsToInert.push(mainEl);

        const footerEl = document.querySelector('footer');
        if (footerEl) elementsToInert.push(footerEl);

        const bodyChildren = document.body.children;
        for (let i = 0; i < bodyChildren.length; i++) {
            const child = bodyChildren[i];
            const tagName = child.tagName.toLowerCase();

            if (tagName === 'script' || tagName === 'style' || tagName === 'link' || tagName === 'noscript') {
                continue;
            }

            if (headerEl && child === headerEl) {
                continue;
            }

            if (elementsToInert.indexOf(child) === -1) {
                elementsToInert.push(child);
            }
        }

        const mainNav = document.getElementById('mainNav');
        if (mainNav) elementsToInert.push(mainNav);

        elementsToInert.forEach(function(el) {
            if (isInert) {
                el.setAttribute('inert', '');
            } else {
                el.removeAttribute('inert');
            }
        });
    }

    // Get the currently active menu level
    function getActiveLevel() {
        const menu = document.getElementById('mp-menu');
        if (!menu) return null;

        // Find the currently active level (open but not overlaid)
        let activeLevel = menu.querySelector('.mp-level.mp-level-open:not(.mp-level-overlay)');

        // If no submenu is open, use the root level that is open
        if (!activeLevel) {
            activeLevel = menu.querySelector('.mp-level.mp-level-open');
        }

        return activeLevel;
    }

    // Get first focusable element in a level
    function getFirstFocusableInLevel(level) {
        if (!level) return null;

        const allElements = level.querySelectorAll('a, button, input, select, textarea, [tabindex]');

        for (let i = 0; i < allElements.length; i++) {
            const el = allElements[i];

            // Skip if tabindex="-1"
            if (el.getAttribute('tabindex') === '-1') continue;
    
            // Skip if hidden
            if (el.offsetParent === null) continue;

            // Check if this element's closest mp-level is our level
            const closestLevel = el.closest('.mp-level');
            if (closestLevel === level) {
                return el;
            }
        }

        return null;
    }

    // Get all focusable elements within the current menu context
    function getFocusableElements() {
        const focusables = [];
        const menu = document.getElementById('mp-menu');
        const trigger = document.getElementById('trigger');

        if (!menu) return focusables;

        let activeLevel = getActiveLevel();

        // If still no active level, use first mp-level
        if (!activeLevel) {
            activeLevel = menu.querySelector('.mp-level');
        }

        if (activeLevel) {
            const allElements = activeLevel.querySelectorAll('a, button, input, select, textarea, [tabindex]');

            allElements.forEach(function(el) {
                if (el.getAttribute('tabindex') === '-1') return;
                if (el.offsetParent === null && el.getAttribute('tabindex') !== '0') return;

                const closestLevel = el.closest('.mp-level');
                if (closestLevel === activeLevel) {
                    focusables.push(el);
                }
            });
        }

        if (trigger && trigger.offsetParent !== null) {
            focusables.push(trigger);
        }

        return focusables;
    }

    // Focus trap handler
    function handleFocusTrap(e) {
        if (e.key !== 'Tab') return;

        const focusables = getFocusableElements();
        if (focusables.length === 0) return;

        e.preventDefault();

        let currentIndex = -1;
        for (let i = 0; i < focusables.length; i++) {
            if (focusables[i] === document.activeElement || focusables[i].contains(document.activeElement)) {
                currentIndex = i;
                break;
            }
        }

        let nextIndex;
        if (e.shiftKey) {
            if (currentIndex <= 0) {
                nextIndex = focusables.length - 1;
            } else {
                nextIndex = currentIndex - 1;
            }
        } else {
            if (currentIndex === -1 || currentIndex >= focusables.length - 1) {
                nextIndex = 0;
            } else {
                nextIndex = currentIndex + 1;
            }
        }

        focusables[nextIndex].focus();
    }

    // Enable focus trap
    function enableFocusTrap() {
        if (!focusTrapHandler) {
            focusTrapHandler = handleFocusTrap;
            document.addEventListener('keydown', focusTrapHandler, true);
        }
    }

    // Disable focus trap
    function disableFocusTrap() {
        if (focusTrapHandler) {
            document.removeEventListener('keydown', focusTrapHandler, true);
            focusTrapHandler = null;
        }
    }

    // Function to update focusability of menu level items
    function updateMenuLevelFocusability() {
        const menu = document.getElementById('mp-menu');
        if (!menu) return;

        const focusableSelector = 'a, button, input, select, textarea, [tabindex]';
        const allFocusables = menu.querySelectorAll(focusableSelector);

        allFocusables.forEach(function(el) {
            const closestLevel = el.closest('.mp-level');
            if (!closestLevel) return;

            const isInOverlaidLevel = closestLevel.classList.contains('mp-level-overlay');

            if (isInOverlaidLevel) {
                if (!el.hasAttribute('data-menu-orig-tabindex')) {
                    el.setAttribute('data-menu-orig-tabindex', el.getAttribute('tabindex') || '');
                }
                el.setAttribute('tabindex', '-1');
            } else {
                if (el.hasAttribute('data-menu-orig-tabindex')) {
                    const origTabindex = el.getAttribute('data-menu-orig-tabindex');
                    if (origTabindex) {
                        el.setAttribute('tabindex', origTabindex);
                    } else {
                        el.removeAttribute('tabindex');
                    }
                    el.removeAttribute('data-menu-orig-tabindex');
                }
            }
        });
    }

    // Handle focus when menu level changes
    function handleMenuLevelChange() {
        const currentActiveLevel = getActiveLevel();

        // Check if the active level has changed
        if (currentActiveLevel && currentActiveLevel !== previousActiveLevel) {
            updateMenuLevelFocusability();

            // Only auto-focus if using keyboard navigation
            if (isKeyboardNavigation) {
                setTimeout(function() {
                    const firstFocusable = getFirstFocusableInLevel(currentActiveLevel);
                    if (firstFocusable) {
                        firstFocusable.focus();
                    }
                }, 50);
            }
        }

        previousActiveLevel = currentActiveLevel;
    }

    // Observe the html element for body-lock class changes
    const htmlObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                const hasBodyLock = document.documentElement.classList.contains('body-lock');
                setPageInertState(hasBodyLock);

                if (hasBodyLock) {
                    enableFocusTrap();
                    previousActiveLevel = getActiveLevel();

                    // Only auto-focus if using keyboard navigation
                    if (isKeyboardNavigation) {
                        setTimeout(function() {
                            const firstFocusable = getFirstFocusableInLevel(previousActiveLevel);
                            if (firstFocusable) {
                                firstFocusable.focus();
                            }
                        }, 50);
                    }
                } else {
                    disableFocusTrap();
                    previousActiveLevel = null;
                    const menu = document.getElementById('mp-menu');
                    if (menu) {
                        const allWithOrigTabindex = menu.querySelectorAll('[data-menu-orig-tabindex]');
                        allWithOrigTabindex.forEach(function(el) {
                            const origTabindex = el.getAttribute('data-menu-orig-tabindex');
                            if (origTabindex) {
                                el.setAttribute('tabindex', origTabindex);
                            } else {
                                el.removeAttribute('tabindex');
                            }
                            el.removeAttribute('data-menu-orig-tabindex');
                        });
                    }
                }
            }
        });
    });

    // Observe menu levels for class changes
    const menuObserver = new MutationObserver(function(mutations) {
        let levelChanged = false;
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                levelChanged = true;
            }
        });

        if (levelChanged) {
            handleMenuLevelChange();
        }
    });

    // Start observing
    htmlObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
    });

    function observeMenuLevels() {
        const menuLevels = document.querySelectorAll('.mp-level');
        menuLevels.forEach(function(level) {
            menuObserver.observe(level, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeMenuLevels);
    } else {
        observeMenuLevels();
    }

    if (document.documentElement.classList.contains('body-lock')) {
        setPageInertState(true);
        updateMenuLevelFocusability();
        enableFocusTrap();
        previousActiveLevel = getActiveLevel();
    }

})();